import React from 'react';
import { useI18n } from '../../../../contexts/I18nContext';
import textGeneratedVideo from '../../../../assets/video/veo_text_generate_video.mp4';
import './Veo2Showcase.scss';

const Veo2Showcase = () => {
  const { t } = useI18n();
  return (
    <section className="veo2-showcase">
      <div className="veo2-showcase__inner">
        <div className="veo2-showcase__media">
          <div className="veo2-showcase__header">
            <span className="dot" />
            {t('videoGeneration.veo.showcase.header')}
            <span className="badge">{t('videoGeneration.veo.showcase.badge')}</span>
          </div>
          <div className="veo2-showcase__canvas">
            <video className="veo2-showcase__video" src={textGeneratedVideo} controls muted playsInline preload="metadata" />
            <div className="veo2-showcase__bar">
              <span className="time">0:00 / 0:08</span>
              <span className="quality">720P</span>
            </div>
          </div>
        </div>

        <div className="veo2-showcase__text">
          <h3 className="title">{t('videoGeneration.veo.showcase.title')}</h3>
          <p className="subtitle">{t('videoGeneration.veo.showcase.subtitle')}</p>

          <div className="prompt">
            <div className="prompt__header">
              <span className="dot" />
              {t('videoGeneration.veo.showcase.promptLabel')}
            </div>
            <div className="prompt__body">
              {t('videoGeneration.veo.showcase.promptText')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Veo2Showcase;